export const primary = {
  primary: {
    color: '#2196f3',
    inverseColor: '#ffffff',
    hoverColor: '#0b7ad1',
    activeColor: '#0b7ad1',
  },
};
